import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CampaignListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/jackpot/details"}
                            objectKeys={["id", "name", "provider_jackpot_id","campaign.name", "type", "contribution_percentage", "value"]}
                            columnTitles={[
                                "ID", "Name", "Provider Jackpot Id", "Campaign Name", "Type", "Contribution Percentage", "Value"
                            ]}
                            pageTitle={"Jackpots"}
                            readEndpoint={"jackpot/read"}
                            relations={["campaign"]}
                            />
        </>
    )
}

export default CampaignListPage;